import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { aboutInfo } from '@/mocks/about';

export default function AboutPage() {
  const orgJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: aboutInfo.brandName,
    url: 'https://www.muguayingyuan.com',
    description: '国内领先的免费在线影视资源平台',
    foundingDate: '2022',
    contactPoint: {
      '@type': 'ContactPoint',
      email: aboutInfo.contact.email,
      contactType: 'customer service',
      availableLanguage: ['Chinese'],
    },
  };

  const aboutJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: `关于${aboutInfo.brandName} - ${aboutInfo.slogan}`,
    description: `${aboutInfo.brandName}${aboutInfo.intro.slice(0, 100)}`,
    url: 'https://www.muguayingyuan.com/about',
  };

  return (
    <div className="min-h-screen bg-background-50">
      <script type="application/ld+json">{JSON.stringify(orgJsonLd)}</script>
      <script type="application/ld+json">{JSON.stringify(aboutJsonLd)}</script>
      <Navbar />
      <main className="pt-20 pb-14">
        <div className="w-full px-4 md:px-6">
          <div className="max-w-5xl mx-auto">
            <Breadcrumb
              items={[
                { label: '首页', path: '/' },
                { label: '关于我们' },
              ]}
            />

            <section className="mt-6">
              <div className="text-center mb-12">
                <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-4">
                  关于{aboutInfo.brandName}
                </h1>
                <p className="text-lg text-foreground-500 font-heading">
                  {aboutInfo.slogan}
                </p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-5 gap-8 mb-16">
                <div className="md:col-span-3">
                  <h2 className="font-heading text-xl font-bold text-foreground-950 mb-4">
                    品牌故事
                  </h2>
                  <div className="text-sm text-foreground-600 leading-relaxed space-y-4">
                    {aboutInfo.intro.split('\n\n').map((para, i) => (
                      <p key={i}>{para}</p>
                    ))}
                  </div>
                </div>
                <div className="md:col-span-2">
                  <div className="rounded-xl overflow-hidden bg-background-200 aspect-[4/3]">
                    <img
                      src="https://readdy.ai/api/search-image?query=Modern%20creative%20office%20space%20with%20warm%20lighting%20and%20wooden%20furniture%2C%20film%20posters%20on%20walls%2C%20comfortable%20sofa%20area%2C%20cinematic%20decoration%2C%20cozy%20atmosphere%2C%20professional%20photography%2C%20warm%20amber%20and%20dark%20tones&width=800&height=600&seq=about-brand&orientation=landscape"
                      alt={`${aboutInfo.brandName} 办公环境`}
                      title={`${aboutInfo.brandName} - 团队办公环境`}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                </div>
              </div>
            </section>

            <section className="mb-16">
              <div className="text-center mb-8">
                <h2 className="font-heading text-xl font-bold text-foreground-950 mb-2">
                  我们的优势
                </h2>
              </div>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                {aboutInfo.features.map((feature) => (
                  <div
                    key={feature.title}
                    className="text-center p-6 rounded-xl bg-background-50 border border-background-200/70"
                  >
                    <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-full bg-primary-500/10">
                      <i className={`${feature.icon} text-2xl text-primary-500`}></i>
                    </div>
                    <h3 className="font-heading text-sm font-semibold text-foreground-950 mb-2">
                      {feature.title}
                    </h3>
                    <p className="text-xs text-foreground-500 leading-relaxed">
                      {feature.description}
                    </p>
                  </div>
                ))}
              </div>
            </section>

            <section className="mb-16">
              <div className="rounded-2xl bg-primary-500/5 border border-primary-500/10 p-8 md:p-10">
                <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
                  {aboutInfo.stats.map((stat) => (
                    <div key={stat.label} className="text-center">
                      <div className="font-heading text-3xl md:text-4xl font-bold text-primary-500 mb-1">
                        {stat.value}
                      </div>
                      <div className="text-xs text-foreground-500">{stat.label}</div>
                    </div>
                  ))}
                </div>
              </div>
            </section>

            <section className="mb-16">
              <div className="text-center mb-8">
                <h2 className="font-heading text-xl font-bold text-foreground-950 mb-2">
                  用户口碑
                </h2>
                <p className="text-sm text-foreground-500">听听真实用户怎么说</p>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                {aboutInfo.testimonials.map((t, idx) => (
                  <div
                    key={idx}
                    className="p-6 rounded-xl bg-background-50 border border-background-200/70"
                  >
                    <div className="flex items-center gap-1 mb-3">
                      {Array.from({ length: t.rating }).map((_, i) => (
                        <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                      ))}
                    </div>
                    <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                      &ldquo;{t.content}&rdquo;
                    </p>
                    <div>
                      <p className="text-sm font-semibold text-foreground-950">{t.name}</p>
                      <p className="text-xs text-foreground-400">{t.role}</p>
                    </div>
                  </div>
                ))}
              </div>
            </section>

            <section id="contact" className="mb-8">
              <div className="text-center mb-8">
                <h2 className="font-heading text-xl font-bold text-foreground-950 mb-2">
                  联系我们
                </h2>
                <p className="text-sm text-foreground-500">有任何问题或建议，欢迎联系我们</p>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-3xl mx-auto">
                <div className="p-6 rounded-xl bg-background-50 border border-background-200/70">
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500/10 flex-shrink-0">
                      <i className="ri-mail-line text-xl text-primary-500"></i>
                    </div>
                    <div>
                      <h4 className="font-heading text-sm font-semibold text-foreground-950 mb-1">
                        电子邮箱
                      </h4>
                      <p className="text-sm text-foreground-500">{aboutInfo.contact.email}</p>
                    </div>
                  </div>
                </div>
                <div className="p-6 rounded-xl bg-background-50 border border-background-200/70">
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500/10 flex-shrink-0">
                      <i className="ri-wechat-line text-xl text-primary-500"></i>
                    </div>
                    <div>
                      <h4 className="font-heading text-sm font-semibold text-foreground-950 mb-1">
                        微信公众号
                      </h4>
                      <p className="text-sm text-foreground-500">{aboutInfo.contact.wechat}</p>
                    </div>
                  </div>
                </div>
                <div className="p-6 rounded-xl bg-background-50 border border-background-200/70">
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500/10 flex-shrink-0">
                      <i className="ri-weibo-line text-xl text-primary-500"></i>
                    </div>
                    <div>
                      <h4 className="font-heading text-sm font-semibold text-foreground-950 mb-1">
                        官方微博
                      </h4>
                      <p className="text-sm text-foreground-500">{aboutInfo.contact.weibo}</p>
                    </div>
                  </div>
                </div>
                <div className="p-6 rounded-xl bg-background-50 border border-background-200/70">
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500/10 flex-shrink-0">
                      <i className="ri-map-pin-line text-xl text-primary-500"></i>
                    </div>
                    <div>
                      <h4 className="font-heading text-sm font-semibold text-foreground-950 mb-1">
                        公司地址
                      </h4>
                      <p className="text-sm text-foreground-500">{aboutInfo.contact.address}</p>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}